export const API_URL = "https://api.idealconsultoriaemarketing.com.br";
